import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}files`;

export interface GetFileQuotesQueryArgs {
  fileId: string;
}

export interface QuoteDto {
  id: string;
  state: string;
  editedDate: string;
  // Keep the rest of fields flexible until a stricter model is required
  [key: string]: unknown;
}

export const getFileQuotesRequest = (
  payload: GetFileQuotesQueryArgs,
): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${payload.fileId}/quotes`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getFileQuotesQuery = async (
  payload: GetFileQuotesQueryArgs,
): Promise<BackResponse<QuoteDto[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<QuoteDto[]>>(
      getFileQuotesRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
